import React from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip, makeStyles } from '@fluentui/react-components'
import {
  DocumentAdd24Regular,
  ThumbLike24Regular,
  ThumbDislike24Regular,
  Copy24Regular
  // Checkmark24Regular,
} from '@fluentui/react-icons'

const useStyles = makeStyles({
  actionsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginTop: '12px',
    paddingTop: '8px',
    borderTop: '1px solid #e0e0e0'
  }
})

/**
 * FeedbackActions Component
 *
 * Renders a row of interactive action buttons typically displayed beneath a bot's response bubble.
 * Actions include:
 * 1. Inserting the response directly into the active Google Document.
 * 2. Copying the response to the user's clipboard.
 * 3. Providing positive (Like) or negative (Dislike) feedback on the response.
 *
 * @param {Object} props - The component properties.
 * @param {Function} props.onFeedback - Callback function triggered when the like or dislike button is clicked. Passes "like" or "dislike" as an argument.
 * @param {Function} props.onCopy - Callback function triggered when the copy button is clicked.
 * @param {string|null} props.feedback - The current feedback state ("like", "dislike", or null/undefined) used to highlight the active selection.
 * @param {Function} props.onInsert - Callback function triggered when the insert button is clicked.
 * @param {boolean} props.isInserting - Indicates if an insertion operation is currently in progress (shows a loading state on the button).
 * @param {boolean} props.isGloballyLoading - Indicates if the application is in a global loading state, which disables all interaction buttons.
 */
const FeedbackActions = ({
  onFeedback,
  onCopy,
  feedback,
  onInsert,
  isInserting,
  isGloballyLoading,
  hideCopy = false,  
  hideInsert = false,
}) => {
  const styles = useStyles()

  return (
    <div className={styles.actionsContainer}>

      {/* WRAP THE INSERT BUTTON */}
      {!hideInsert && (
        <Tooltip content="Insert into document" relationship="label">
          <Button appearance='subtle' icon={<DocumentAdd24Regular />} onClick={onInsert} disabled={isGloballyLoading || isInserting} />
        </Tooltip>
      )}
      {/* WRAP THE COPY BUTTON */}
      {!hideCopy && (
        <Tooltip content="Copy to clipboard" relationship="label">
          <Button appearance='subtle' icon={<Copy24Regular />} onClick={onCopy} disabled={isGloballyLoading} />
        </Tooltip>
      )}
          
          {/*<Tooltip content='Insert into Document' relationship='label'>
        <Button
          appearance='subtle'
          icon={<DocumentAdd24Regular />}
          onClick={onInsert}
          // A button is disabled if it's inserting OR if the app is loading
          disabled={isInserting || isGloballyLoading}
        >
          {isInserting ? 'Inserting...' : ''}
        </Button>
      </Tooltip>
      <Tooltip content='Copy response' relationship='label'>
        <Button
          appearance='subtle'
          icon={<Copy24Regular />}
          onClick={onCopy}
          disabled={isGloballyLoading}
        />
      </Tooltip> */}

      <Tooltip content='Good response' relationship='label'>
        <Button
          appearance={feedback === 'like' ? 'primary' : 'subtle'}
          icon={<ThumbLike24Regular />}
          onClick={() => onFeedback('like')}
          disabled={isGloballyLoading}
        />
      </Tooltip>
      <Tooltip content='Bad response' relationship='label'>
        <Button
          appearance={feedback === 'dislike' ? 'primary' : 'subtle'}
          icon={<ThumbDislike24Regular />}
          onClick={() => onFeedback('dislike')}
          disabled={isGloballyLoading}
        />
      </Tooltip>
    </div>
  )
}

FeedbackActions.propTypes = {
  onFeedback: PropTypes.func.isRequired,
  onCopy: PropTypes.func.isRequired,
  feedback: PropTypes.string,
  onInsert: PropTypes.func.isRequired,
  isInserting: PropTypes.bool,
  isGloballyLoading: PropTypes.bool,
  hideCopy:  PropTypes.bool, 
  hideInsert: PropTypes.bool,   
}

export default FeedbackActions
